module.exports = "<searchbar is-disabled=\"$ctrl.loading.products\" search-text=\"$ctrl.filters.search.text\" search-terms=\"$ctrl.filters.search.terms\" search-placeholder=\"store.search\" on-search=\"$ctrl.onSearch()\"></searchbar>\n<div class=\"shop-search-item\" ng-click='$ctrl.shopSelected(shop)' ng-repeat=\"shop in $ctrl.filteredList track by $index\">\n  {{shop.option}}\n</div>\n<div class=\"action-buttons\">\n  <button class=\"button secondary\" ng-click=\"$ctrl.onCancel()\">{{'common.buttons.close' | translate}}</button>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/common/components/storeSelect/search/search.html
 ** module id = 377
 ** module chunks = 0
 **/